export const lang = {
    "item1":"約",
    "item2":"製品とサービス",
    "item3":"お問い合わせ",
    "intro1":"NDC（New Distribution Capability）は、国際航空運送協会（IATA）の新しい流通規格です。航空会社は、NDC規格を通じて、豊富な製品情報、パーソナライズされた製品、および完全なサービス機能をエージェントに提供できます。",
    "intro2":"SmartNDCは、航空会社のNDCサービスのアグリゲーターであり、エージェントが航空会社のNDCに接続するのを支援し、シンプルでリッチなJSON APIインターフェース、オンライン予約ツール、モバイル予約ページなどを提供します。 エージェントの顧客管理とチャネル配布のニーズを満たすことができます。 NDCベースの座席選択、荷物、VIPルーム、往復、マルチトリップなどをサポートします。",    
    "title1":"オンライン予約ツール",
    "subtitle1":"航空会社のNDC製品のオンライン予約と管理は、カスタマイズと配布のニーズを満たします。",
    "title2":"モバイル予約ページ",
    "subtitle2":"アダプティブモバイル予約ページは、モバイルアクセスやモバイルアプリケーションへの埋め込みに便利です。",    
    "title3":"簡潔なJSON API",
    "subtitle3":"基本的な予約と発券の要件を満たし、開発と統合の複雑さを軽減します。",
    "title4":"詳細なJSON API",
    "subtitle4":"航空会社のNDCのすべての機能をサポートし、さまざまなアプリケーションの開発を容易にします。",       
    "title5":"オプションのクラウドサービス",
    "subtitle5":"柔軟で迅速な使用により、導入と運用のコストを削減します。",
    "title6":"ローカルに展開できます",
    "subtitle6":"個人データのセキュリティを確保するために、カスタマイズおよび開発することができます。",    
    "title7":"機能のアップグレード",
    "subtitle7":"NDCテクノロジーの開発に適応するための継続的な無料の製品機能アップグレード。",
    "title8":"テクニカルサービス",
    "subtitle8":"中断のない操作を保証するための7 * 24時間の技術サービス。",        
    "copyright":"北京点動創想科技有限公司", 
    "c_name":"名前*", 
    "c_email":"Eメール*", 
    "c_phone":"電話*", 
    "c_message":"コンサルティング情報*", 
    "c_send":"送信", 
}